import { Component, OnInit, Input, SimpleChanges, OnChanges, EventEmitter, Output, Inject, OnDestroy, forwardRef } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles 
} from './models/control';
import { GridHeaderModel, GridCellModel, GridRowModel, CellStyles, GridContainerStyle, HeaderStyles } from './models/grid'
import { FieldModel } from './models/field'
import { ToolModel } from './models/tool';
import { Styles, ControlContainerStyles } from './models/style';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { isEqual, isNil, set } from 'lodash-es';
import { GridComponent, ELoadingStatus } from './components/grid.component';
import { BaseComponent } from './components/base.component';
import { WorkBook, read as readExcelFile, writeFile as writeExcelFile, utils as excelUtils } from 'xlsx';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { Equipment_ShellService } from './Equipment.shell.service';
import { Equipment_OperationService } from './Equipment.operation.service';
import { Equipment_DatasourceService } from './Equipment.datasource.index';
import { Equipment_FlowService } from './Equipment.flow.index';
import { Equipment_ReportService } from './Equipment.report.index';
import { Equipment_LocalizationService } from './Equipment.localization.service';
import { Equipment_equipment_warehouses_grid_ComponentContextService } from './Equipment.equipment_warehouses_grid.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './Equipment.frontend.types'
import { $frontendTypes as $types} from './Equipment.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';


interface IEquipment_equipment_warehouses_gridComponentEntity {
  EquipmentId?: number, LocationContainerId?: number, LocationContainer?: { Id?: number, Name?: string, Warehouse?: { Id?: number, Name?: string } }, Equipment?: { Id?: number, LookupCode?: string }}

interface IEquipment_equipment_warehouses_gridComponentInParams {
  equipmentId: number}


class Equipment_equipment_warehouses_gridComponentRowModel extends GridRowModel {
  grid: Equipment_equipment_warehouses_gridComponent;
  entity: IEquipment_equipment_warehouses_gridComponentEntity;



 // temporarily put required on all edit controls
  override formGroup = new FormGroup({
  });

  override cells = {
    Name: null,
  }



  constructor(
    grid: Equipment_equipment_warehouses_gridComponent,
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: Equipment_ShellService,
private $datasources: Equipment_DatasourceService,
private $flows: Equipment_FlowService,
private $reports: Equipment_ReportService,
private $localization: Equipment_LocalizationService,
private $operations: Equipment_OperationService,
private $logger: CleanupLoggerService,
private $context: Equipment_equipment_warehouses_grid_ComponentContextService,
) {
    super();

    this.grid = grid;

    this.cells.Name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    
  }

  async $initializeExisting(entity: IEquipment_equipment_warehouses_gridComponentEntity) {
    this.entity = entity;

    this.rowId = [this.entity.EquipmentId,this.entity.LocationContainerId].join('-');

    await this.$dataLoaded();
  }

  async $initializeNew(entity?: IEquipment_equipment_warehouses_gridComponentEntity) {
    this.isNew = true;

    if (entity) {
      this.entity = entity;
    }
    else {
      this.entity = {};
    }

    this.rowId = [this.entity.EquipmentId,this.entity.LocationContainerId].join('-');
    await this.$dataLoaded();
    // mark the whole form as dirty, since this is a new row 
    // and even if it is valid, it should have a changed state
    this.formGroup.markAsDirty();
  }

  private $unsubscribe$ = new Subject();
  override destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $init() {
  }

  async $dataLoad() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    const $resultKey = {};
    set($resultKey, 'EquipmentId',this.entity.EquipmentId);
    set($resultKey, 'LocationContainerId',this.entity.LocationContainerId);
    const inParams = {
      $keys:[$resultKey],
      equipmentId:  $grid.inParams.equipmentId ,
    };
    const data = await this.$datasources.Equipment.ds_equipment_warehouses_grid.getByKeys(inParams);
    
    await this.grid.$applyLinkedDatasourcesAndCustomColumns(inParams, data);
      
    this.entity = data.result[0] as IEquipment_equipment_warehouses_gridComponentEntity;
    await this.$dataLoaded();
  }

  async $dataLoaded() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    (this.cells.Name.displayControl as TextModel).text = $row.entity.LocationContainer.Warehouse.Name;

  }

  override async refresh() {
    if (this.grid.$hasMissingRequiredInParams) {
      return Promise.resolve(null);
    }
    await this.$dataLoad();
    // grid refresh skipSelf=true, skipParent=false, skipChildren=false  
    this.grid.$refreshEvent.emit();
  }

  override async save() {
    if (this.isNew) {
    } else {
    } 
  }

  override $cellClicked(cellId: string) {
    super.$cellClicked(cellId);
    switch(cellId) {
    }
  }


}


@Component({
  standalone: true,
  imports: [
    SharedModule,
  ],
  selector: 'Equipment-equipment_warehouses_grid',
  templateUrl: './Equipment.equipment_warehouses_grid.component.html'
})
export class Equipment_equipment_warehouses_gridComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  entities: IEquipment_equipment_warehouses_gridComponentEntity[];

  pageSize = 10;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus = ELoadingStatus.Loading;


// to stop add from flow
// canAdd = false; //hide add button, check on exitFromLastCell 
// bottomToolbar.addLine.hidden = true; //hide add button, no check on exitFromLastCell 
// bottomToolbar.addLine.control.readOnly = true; //disable add button, check on exitFromLastCell 
 
  
  containerStyles: GridContainerStyle = new GridContainerStyle('headersWidth', null);


  inParams: IEquipment_equipment_warehouses_gridComponentInParams = { equipmentId: null };


  //#region Variables
  //#endregion
  //#region Events
  
  //#endregion

  headers = {
     Name: new GridHeaderModel(new HeaderStyles(null, null), 'Name', 'Name', false, false, null, false),  
  };

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  rows: Equipment_equipment_warehouses_gridComponentRowModel[] = [];

  @Input('equipmentId') set $inParams_equipmentId(value: any) {
    this.inParams['equipmentId'] = value;
  }
  get $inParams_equipmentId(): any {
    return this.inParams['equipmentId'] ;
  }

  topToolbar = {
      addWarehouseButton: new ToolModel(new ButtonModel('addWarehouseButton', new ButtonStyles(null, null), false, false, false, 'Add warehouse', 'icon-ic_fluent_add_20_regular', null)
    , false),
      removeButton: new ToolModel(new ButtonModel('removeButton', new ButtonStyles(null, null), false, false, false, 'Remove selected', 'icon-ic_fluent_window_header_horizontal_off_20_regular', null)
    , false)
  };

  bottomToolbar = {
  };




  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: Equipment_ShellService,
    private $datasources: Equipment_DatasourceService,
    private $flows: Equipment_FlowService,
    private $reports: Equipment_ReportService,
    private $localization: Equipment_LocalizationService,
    private $operations: Equipment_OperationService,
    private $logger: CleanupLoggerService,
    private $context: Equipment_equipment_warehouses_grid_ComponentContextService,
    ) {
    super();
    this.title = 'Warehouses';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$checkRequiredInParams();
    if (!this.$hasMissingRequiredInParams) {
      this.$init();
    } else {
      this.$initEmpty();
    }
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$checkRequiredInParams();
      if(!this.$hasMissingRequiredInParams) {
        this.$init();
      } else {
        this.$initEmpty();
      }
    }
  }

  $missingRequiredInParams = [];
  get $hasMissingRequiredInParams(): boolean {
    return !!this.$missingRequiredInParams.length;
  }
  
  $checkRequiredInParams() {
    this.$missingRequiredInParams = [];
      if(isNil(this.inParams.equipmentId)) {
        this.$missingRequiredInParams.push('equipmentId');
      }
  }

  initialized = false;

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();

    this.clearRows();
  }

  async $init() {
    const $grid = this;
    const $utils = this.$utils;

    this.pageSize = 10;


    await this.on_init();
    this.initialized = true;

    this.pageSkip = 0;
    this.refresh(true, true, null);
  }

  protected override $initEmpty() {
    this.clearRows();
  }

  private $subscribeFormControlValueChanges() {

  }

  reload() {
    this.pageSkip = 0;
    this.refresh();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    if (this.$hasMissingRequiredInParams) {
      return Promise.resolve(null);
    }
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  async $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    const $grid = this;
    const $utils = this.$utils;
    const inParams = {
      $top: this.pageSize,
      $skip: this.pageSkip,
      equipmentId:  $grid.inParams.equipmentId ,
    };
    try {
      const data = await this.$datasources.Equipment.ds_equipment_warehouses_grid.getList(inParams);
      
      await this.$applyLinkedDatasourcesAndCustomColumns(inParams, data);

      this.entities = data.result as IEquipment_equipment_warehouses_gridComponentEntity[];
      this.totalCount = data.totalCount;

      await this.$dataLoaded();
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    } catch(error) {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    }
  }

  async $dataLoaded() {
    const $grid = this;
    const $utils = this.$utils;
    
    this.clearRows();

    if(this.entities) {
      let rowLoadPromises = [];
      for (let entity of this.entities) {
        const row = new Equipment_equipment_warehouses_gridComponentRowModel(
          this,
          this.$utils,
          this.$settings,
          this.$shell, 
          this.$datasources,
          this.$flows,
          this.$reports,
          this.$localization,
          this.$operations,
          this.$logger,
          this.$context);
        rowLoadPromises.push(row.$initializeExisting(entity));
        this.rows.push(row);
      }
      await Promise.all(rowLoadPromises);
    }

  }

  
    async $applyLinkedDatasourcesAndCustomColumns(inParams: any, outParams: any) {
      const $datasource = { inParams: inParams };
      const $utils = this.$utils;
  
    }

  clearRows() {
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
    this.rows = [];
  }

  selectedRows: Equipment_equipment_warehouses_gridComponentRowModel[] = [];
  hasSelectedRows() {
    return this.selectedRows.length > 0;
  }

  async $selectionChanged(selectedRows: any[]) {
    this.selectedRows = selectedRows;
    await this.on_row_selected();
  }

  
  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_add_clicked(event = null) {
    return this.on_add_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_add_clickedInternal(
    $grid: Equipment_equipment_warehouses_gridComponent,
  
    $shell: Equipment_ShellService,
    $datasources: Equipment_DatasourceService,
    $flows: Equipment_FlowService,
    $reports: Equipment_ReportService,
    $settings: SettingsValuesService,
    $operations: Equipment_OperationService,
    $utils: UtilsService,
    $context: Equipment_equipment_warehouses_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: Equipment_LocalizationService,
    $event: any
  ) {
  try {
  
      const result = await $shell.Equipment.openadd_warehouse_to_equipment_formDialog({ equipmentId: $grid.inParams.equipmentId }, 'flyout');
  
      if(result.confirmed === true)
          $grid.refresh();
          
  }
  catch(error) {
  
      while ($utils.isDefined(error.error)) {
          if(!$utils.isDefined(error.message))
              break;
  
          error = error.error;
      }
  
      $shell.Utilities.openErrorDialog('Could not add warehouse to equipment', error)
  }
  }
  on_remove_clicked(event = null) {
    return this.on_remove_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_remove_clickedInternal(
    $grid: Equipment_equipment_warehouses_gridComponent,
  
    $shell: Equipment_ShellService,
    $datasources: Equipment_DatasourceService,
    $flows: Equipment_FlowService,
    $reports: Equipment_ReportService,
    $settings: SettingsValuesService,
    $operations: Equipment_OperationService,
    $utils: UtilsService,
    $context: Equipment_equipment_warehouses_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: Equipment_LocalizationService,
    $event: any
  ) {
  try {
      
      $grid.topToolbar.addWarehouseButton.control.readOnly = true;
      $grid.topToolbar.removeButton.control.readOnly = true;
  
      let didConfirm = false;
  
      if($grid.selectedRows.length == 1) {
          didConfirm = await $shell.Utilities.openConfirmationDialog('Confirm warehouse removal', `Confirm removing warehouse [${$grid.selectedRows[0].entity.LocationContainer.Warehouse.Name}] from equipment [${$grid.selectedRows[0].entity.Equipment.LookupCode}]`) as boolean;
      }
      else {
          didConfirm = await $shell.Utilities.openConfirmationDialog('Confirm warehouse removal', `Confirm removing [${$grid.selectedRows.length}] warehouses from equipment [${$grid.selectedRows[0].entity.Equipment.LookupCode}]`) as boolean;
      }
  
      if(didConfirm) {
  
          for(const row of $grid.selectedRows) {
              const deleteResult = await $flows.Equipment.remove_warehouse_from_equipment({ equipmentId: $grid.inParams.equipmentId, warehouseId: row.entity.LocationContainer.Warehouse.Id });
  
              if(deleteResult.reasons.length > 0)
                  throw new Error(deleteResult.reasons[0]);
          }
  
          $grid.refresh();
  
      }
      
  }
  catch(error) {
  
      while ($utils.isDefined(error.error)) {
          if(!$utils.isDefined(error.message))
              break;
  
          error = error.error;
      }
  
      $shell.Utilities.openErrorDialog('Could not remove warehouse from equipment', error);
      
  } finally {
  
      $grid.topToolbar.addWarehouseButton.control.readOnly = false;
      $grid.topToolbar.removeButton.control.readOnly = false;
  
  }
  }
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $grid: Equipment_equipment_warehouses_gridComponent,
  
    $shell: Equipment_ShellService,
    $datasources: Equipment_DatasourceService,
    $flows: Equipment_FlowService,
    $reports: Equipment_ReportService,
    $settings: SettingsValuesService,
    $operations: Equipment_OperationService,
    $utils: UtilsService,
    $context: Equipment_equipment_warehouses_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: Equipment_LocalizationService,
    $event: any
  ) {
  $grid.topToolbar.removeButton.control.readOnly = true;
  }
  on_row_selected(event = null) {
    return this.on_row_selectedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_selectedInternal(
    $grid: Equipment_equipment_warehouses_gridComponent,
  
    $shell: Equipment_ShellService,
    $datasources: Equipment_DatasourceService,
    $flows: Equipment_FlowService,
    $reports: Equipment_ReportService,
    $settings: SettingsValuesService,
    $operations: Equipment_OperationService,
    $utils: UtilsService,
    $context: Equipment_equipment_warehouses_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: Equipment_LocalizationService,
    $event: any
  ) {
  if($grid.selectedRows.length > 0) {
      $grid.topToolbar.removeButton.control.readOnly = false;
  }
  else {
      $grid.topToolbar.removeButton.control.readOnly = true;
  }
  }
  //#endregion private flows


 
  close() {
    this.$finish.emit();
  }
}
